module.exports = __webpack_public_path__ + "static/maiacopywhite-9c51487383d8b8c3b371e3ded3ff30b9.png";